module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image16.dbf37d92.jpg";